module.exports = __webpack_public_path__ + "static/media/boat-img-7.53051801.jpg";